export const getBranchTransferColumnDefs = (translations) => {
    const bt = translations.branchTransfer || {}
    const cs = translations.common || {}
    const ColumnDefs = [
    { isHeader: true, header:  bt.detailedTable},
    {
        id: 1, header: bt.srNo,
        exportHead: bt.SR,
        field: 'srNo',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 40
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 2, header: bt.destCity,
        exportHead: bt.destCity,
        field: 'DestinationCity',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 3, header: bt.destinationBranch,
        exportHead: bt.destBranch,
        field: 'DestinationBranch',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 4, header:  bt.lrNo,
        exportHead:  bt.lrNo,
        field: 'LRNO',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 5, header: bt.sendName,
        exportHead: bt.sendName,
        field: 'Sender',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 6, header: bt.recName,
        exportHead: bt.recName,
        field: 'RecName',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 7, header: bt.itemTypeQuantity,
        exportHead:  bt.itemTypeQty,
        field: 'ItemType',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 95
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 8, header:  bt.payType,
        exportHead:  bt.payType,
        field: 'PaymentType',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 9, header: bt.freight,
        exportHead: bt.freight,
        field: 'Freight',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 10, header: bt.cartage,
        exportHead: bt.cartage,
        field: 'AllCartage',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 11, header: bt.hamali,
        exportHead: bt.hamali,
        field: 'AllHamali',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 12, header: bt.valuation,
        exportHead: bt.valuation,
        field: 'Valuation',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 13, header: bt.otherCharge,
        exportHead: bt.otherCharge,
        field: 'OtherChg',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 14, header: bt.gst,
        exportHead: bt.gst,
        field: 'ServiceTaxAmount',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 15, header: bt.allTotal,
        exportHead: bt.allTotal,
        field: 'totalplusGST',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 16, header: bt.comments,
        exportHead: bt.comments,
        field: 'Remarks',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null },
    },
    {
        id: 16, header: bt.ewbNo,
        exportHead: bt.ewbNo,
        field: 'EWayBillNo',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null },
    },
    {
        id: 16, header: bt.ewbStatus,
        exportHead: bt.ewbStatus,
        field: 'EWayBillStatus2',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null },
    },
    { isHeader: true, header: bt.summaryTable},
    {
        id: 17, header: cs.paymentType,
        exportHead: cs.paymentType,
        field: 'PaymentType',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 90
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'string', dataFormatter: null, },
    },
    {
        id: 18, header: bt.totalFreight,
        exportHead: bt.totalFreight,
        field: 'Freight',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 19, header: bt.totalCartage,
        exportHead: bt.totalCartage,
        field: 'AllCartage',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 20, header: bt.totalHamali,
        exportHead: bt.totalHamali,
        field: 'AllHamali',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 21, header: bt.totalValuation,
        exportHead: bt.totalValuation,
        field: 'Valuation',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 22, header: bt.totalOtherCharges,
        exportHead: bt.totalOtherCharges,
        field: 'OtherChg',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 23, header: bt.totalAmount,
        exportHead: bt.totalAmount,
        field: 'total',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 24, header: bt.totalGst,
        exportHead: bt.totalGst,
        field: 'ServiceTaxAmount',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 25, header: bt.totalPlusGst,
        exportHead: bt.totalPlusGst,
        field: 'totalplusGST',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
]
    return ColumnDefs || [];
}